angular.module("contattiPratica.components", [])
    .component("contattiPratica", {
        templateUrl: "ng/components/monitorPratica/contattiPratica/contattiPratica.view.html",
        bindings: {
            digitalModel: "<"
        },
        controller: ContattiPraticaController,
        controllerAs: "contattiPraticaCtrl"

    })

function ContattiPraticaController(
    $simulationService
) {

    var self = this;

    self.$onInit = () => {

        self.supportModel = {
            enableModify: false,
            loaderRest: true
        }

        self.model = {
            mailCustomer: "",
            mailVendor: "",
            mailVendor2: "",
            mailVendor3: ""
        }

        getcontatti();

    }

    self.modifyContact = () => {
        self.supportModel.enableModify = !self.supportModel.enableModify;

        if (!self.supportModel.enableModify) {
            self.supportModel.loaderRest = true;
            saveContattiChecklist();
        }
    }

    var getcontatti = () => {

        $simulationService.contattiChecklist(self.digitalModel.id)
            .then((response) => {
                console.log(response);
                self.supportModel.loaderRest = false;
                self.model.mailCustomer = response.mailCustomer
                self.model.mailVendor = response.mailVendor
                self.model.mailVendor2 = response.mailVendor2
                self.model.mailVendor3 = response.mailVendor3
            })
            .catch((error) => {
                console.log(error);
                self.supportModel.loaderRest = false;
            })

    }

    var saveContattiChecklist = () => {

        var inputRest = JSON.parse(JSON.stringify(self.model));

        Object.assign(inputRest, { id: self.digitalModel.id })


        $simulationService.saveContattiChecklist(inputRest)
            .then((response) => {
                if (response.success) {

                    self.supportModel.loaderRest = false;
                } else {
                    self.supportModel.loaderRest = false;
                    self.supportModel.enableModify = true;
                }
            })
            .catch((error) => {
                console.log(error);
                self.supportModel.loaderRest = false;
            })


    }

    self.handleChange = (name, value) => {

        self.model[name] = value;
    }
}